import {
  ArrowBackCompIcon,
  ChevronDownIcon,
  CloseOutlinedCompIcon,
} from 'assets/icons';
import classes from './styles.module.scss';
import useTranslation from 'hooks/useTranslation';
import routes from 'routes';
import WithLink from 'components/WithLink';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setSecondMenuCollapsed } from 'redux/layout/layout.actions';
import { useState } from 'react';
import { AssignOperatorsModal } from 'components';

const getSelectedWorkspace = ({ websitesData }) =>
  websitesData.selectedWorkspace;
const getIsSecondSideMenuCollapsed = ({ layoutData }) =>
  layoutData.isSecondMenuCollapsed;
const getSecondMenuKey = ({ layoutData }) => layoutData.secondMenuKey;

function SecondSideMenu({ setShowMenu }) {
  const selectedWorkspace = useSelector(getSelectedWorkspace);
  const isSecondSideMenuCollapsed = useSelector(getIsSecondSideMenuCollapsed);
  const secondMenuKey = useSelector(getSecondMenuKey);

  const location = useLocation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState('');

  const {
    //  getTranslation,
    getAppLocale,
  } = useTranslation('WEBSITES');
  // const { t } = getTranslation();
  const locale = getAppLocale();
  const Icon = secondMenuKey?.icon;

  const firstPageUrlPathname = location.pathname;

  const WIDGETـSETTINGS_ITEMS = [
    {
      text_fa: 'نصب و راه اندازی',
      text_en: 'Installation',
      link_to: routes.widgetInstallation,
      isExternalLink: false,
    },
    {
      text_fa: 'پایگاه دانش',
      text_en: 'Knowledge Base',
      link_to: undefined,
      isExternalLink: false,
      subItems: [
        {
          text_fa: 'لیست پرسش ها',
          text_en: 'FAQ List',
          link_to: routes.faqList,
          isExternalLink: false,
          closeSecondMenuOnClick: true,
        },
        {
          text_fa: 'ایجاد پرسش جدید',
          text_en: 'Add New FAQ',
          link_to: routes.addFaq,
          isExternalLink: false,
          closeSecondMenuOnClick: true,
        },
        {
          text_fa: 'شخصی سازی پایگاه دانش',
          text_en: 'FAQ Customization',
          link_to: routes.knowledgeBasePage,
          isExternalLink: false,
          closeSecondMenuOnClick: true,
        },
      ],
    },
    // {
    //   text_fa: 'تنظیمات تیم',
    //   text_en: 'Team Settings',
    //   link_to: undefined,
    //   isExternalLink: false,
    // },
    {
      text_fa: 'دپارتمان بندی',
      text_en: 'Departments',
      link_to: routes.teams,
      isExternalLink: false,
    },
    {
      text_fa: 'تخصیص لینک به اپراتور',
      text_en: 'Assign Link To Operator',
      link_to: routes.settingsTeam,
      isExternalLink: false,
    },
    {
      text_fa: 'پیام گروهی',
      text_en: 'Group Messaging',
      link_to: routes.groupMessage,
      isExternalLink: false,
    },
    {
      text_fa: 'واتس آپ',
      text_en: 'Whatsapp',
      link_to: routes.connectWhatsapp,
      isExternalLink: false,
    },
    // {
    //   text_fa: 'تنظیمات عمومی',
    //   text_en: 'General Settings',
    //   link_to: `/settings/widget#general-settings`,
    //   isExternalLink: false,
    // },
    {
      text_fa: 'شخصی سازی',
      text_en: 'Customize',
      link_to: `/settings/widget#customization`,
      isExternalLink: false,
    },
    {
      text_fa: 'زمان های کاری',
      text_en: 'Working Hours',
      link_to: `/settings/office-hours`,
      isExternalLink: false,
    },
    {
      text_fa: 'ایمیل یاد آوری',
      text_en: 'Email Reminder',
      link_to: `/settings/email`,
      isExternalLink: false,
    },
    {
      text_fa: 'هوشمند سازی',
      text_en: 'Make Smart', // I couldn't find a better name for it XD
      link_to: `/settings/auto-message`,
      isExternalLink: false,
    },
    {
      text_fa: 'حالت انتظار',
      text_en: 'Waiting Mode',
      link_to: `/settings/response-delay`,
      isExternalLink: false,
    },
    {
      text_fa: 'فرم ساز',
      text_en: 'Form Generator',
      link_to: `/settings/form-generator`,
      isExternalLink: false,
    },
    {
      text_fa: 'ربات پاسخگو',
      text_en: 'Responsive Robot',
      link_to: `/settings/responsive-robot`,
      isExternalLink: false,
    },
    {
      text_fa: 'چت‌ بات هوش مصنوعی',
      text_en: 'Intelligent Robot',
      link_to: `/settings/ai-bot`,
      isExternalLink: false,
    },
  ];

  const STATS_ITEMS = [
    {
      text_fa: 'آمار مکالمات',
      text_en: 'Conversations Statistics',
      link_to: routes.conversationsReport,
      isExternalLink: false,
    },
    {
      text_fa: 'آمار اپراتور ها',
      text_en: 'Operators Statistics',
      link_to: routes.operatorsReport,
      isExternalLink: false,
    },
    {
      text_fa: 'آمار رضایت مشتری',
      text_en: 'User Satisfaction Statistics',
      link_to: routes.costumerSuccess,
      isExternalLink: false,
    },
    {
      text_fa: 'آرشیو مکالمات',
      text_en: 'Conversations Archive',
      link_to: `/conversations-archive/all`,
      isExternalLink: false,
    },
    {
      text_fa: 'آرشیو کاربران',
      text_en: 'Users Archive',
      link_to: routes.userVisitsArchive,
      isExternalLink: false,
    },
    {
      text_fa: 'آمار پلتفرم ها',
      text_en: 'Platforms Statistics',
      link_to: routes.platformsReport,
      isExternalLink: false,
    },
    {
      text_fa: 'آمار کاربران',
      text_en: 'Users Statistics',
      link_to: routes.usersReport,
      isExternalLink: false,
    },
  ];

  const getTheItems = () => {
    if (secondMenuKey?.key_name === 'Widget-Settings') {
      return WIDGETـSETTINGS_ITEMS;
    } else if (secondMenuKey?.key_name === 'Stats') {
      return STATS_ITEMS;
    }
  };

  return (
    <div
      className={classes.second_side_menu_wrapper}
      data-second-menu-collapse={isSecondSideMenuCollapsed}
      // ref={secondSidemenuWrapperRef}
    >
      <div className={classes.go_back_or_exit}>
        <div
          onClick={() => {
            dispatch(setSecondMenuCollapsed(true));
            setShowMenu(true);
          }}
          className={classes.go_back_option}
        >
          <ArrowBackCompIcon />
        </div>

        <div
          onClick={() => {
            dispatch(setSecondMenuCollapsed(true));
          }}
          className={classes.exit_option}
        >
          <CloseOutlinedCompIcon />
        </div>
      </div>

      <div className={classes.header}>
        <div className={classes.icon_box}>{Icon && <Icon />}</div>
        <div className={classes.text}>
          {locale === 'fa' ? secondMenuKey?.text_fa : secondMenuKey?.text_en}
        </div>
      </div>
      <div className={classes.body}>
        {secondMenuKey?.key_name === 'Widget-Settings' && (
          <AssignOperatorsModal
            showSecondMenuAssignment
            websiteId={selectedWorkspace?.id}
          />
        )}

        {getTheItems()?.map((item, idx) => {
          return (
            <div key={idx}>
              <WithLink
                link={item.link_to}
                isExternalLink={item.isExternalLink}
              >
                <div
                  className={'second_menu_item_wrapper'}
                  data-selected={item?.link_to?.includes(firstPageUrlPathname)}
                  onClick={() => {
                    if (!!item?.link_to) {
                      dispatch(setSecondMenuCollapsed(true));
                    } else if (!!item?.subItems?.length) {
                      if (open === item.text_en) {
                        setOpen('');
                      } else {
                        setOpen(item.text_en);
                      }
                    }
                  }}
                >
                  {locale === 'fa' ? item.text_fa : item.text_en}

                  {!!item?.subItems?.length && (
                    <div
                      data-open={open === item.text_en}
                      className={classes.arrow_container}
                    >
                      <ChevronDownIcon />
                    </div>
                  )}
                </div>
              </WithLink>

              <div
                className={classes.subisWrapper}
                style={{
                  height:
                    open === item.text_en
                      ? (item?.subItems?.length || 0) * 26 // height of each subi
                      : 0,
                }}
                data-open={open === item.text_en}
              >
                {item?.subItems?.map((subi, index) => {
                  return (
                    <WithLink
                      isExternalLink={subi.isExternalLink}
                      link={subi.link_to}
                      className={classes.subiStyles}
                      onClick={() => {
                        if (!!subi?.closeSecondMenuOnClick) {
                          dispatch(setSecondMenuCollapsed(true));
                        }
                      }}
                    >
                      {locale === 'fa' ? subi.text_fa : subi.text_en}
                    </WithLink>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SecondSideMenu;
